<div class="row" *ngIf="currentUrl == 'users-add' ">
  <div class="col-12">
    <div class="content-header">User Form</div>
  </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input" *ngIf="currentUrl == 'users-add' ">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Basic</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form [formGroup]="userForm">
                  <div>
                  <fieldset class="form-group">
                    <label for="users-list-role">Role</label>                    
                    <!-- <ng-select
                      [items]="roles"
                      bindLabel="type"
                      bindValue="_id"
                      [multiple]="false"
                      [closeOnSelect]="false"
                      placeholder="Select Role"
                      [(ngModel)]="selectedRole"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getRoleId($event)"
                    >
                    </ng-select> -->
                    <input
                      type="text"
                      class="form-control"
                      formControlName="roles"
                      id="roles"
                      placeholder="Enter role"
                      [ngClass]="{
                        'is-invalid': userFormSubmitted && rf.roles.invalid,
                        'is-valid': userFormSubmitted && !rf.roles.invalid
                      }"
                      required
                      #roles
                    />
                    <div
                      *ngIf="rf.roles.touched && rf.roles.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> role is
                      required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="name">Name</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="name"
                      id="name"
                      placeholder="Enter name"
                      [ngClass]="{
                        'is-invalid': userFormSubmitted && rf.name.invalid,
                        'is-valid': userFormSubmitted && !rf.name.invalid
                      }"
                      required
                      #name
                    />
                    <div
                      *ngIf="rf.name.touched && rf.name.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Name is
                      required
                    </div>
                  </fieldset>

                  <fieldset class="form-group">
                    <label for="Email">Email</label>
                    <input
                      type="email"
                      class="form-control"
                      formControlName="email"
                      id="Email"
                      placeholder="Enter email"
                      [ngClass]="{
                        'is-invalid': userFormSubmitted && rf.email.invalid,
                        'is-valid': userFormSubmitted && !rf.email.invalid
                      }"
                      required
                      #email
                    />
                    <div
                      *ngIf="rf.email.touched && rf.email?.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Email is
                      required
                    </div>
                    <div
                      *ngIf="rf.email.errors?.email"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Please enter
                      a valid email address
                    </div>
                  </fieldset>

                  <fieldset class="form-group">
                    <label for="phone">Phone</label>
                    <input
                    type="text" 
                    placeholder="e.g. (555) 555 5555" mask="(000) 000-0000" minlength="10"
                      formControlName="phone"
                      class="form-control"
                      id="phone"
                      placeholder="Enter phone"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.phone.invalid,
                        'is-valid':
                          userFormSubmitted && !rf.phone.invalid
                      }"
                      required
                      #phone
                    />
                    <div
                      *ngIf="
                        rf.phone.touched && rf.phone.errors?.required
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i>
                      phone is required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="address">Address</label>
                    <!-- <input
                      type="text"
                      formControlName="location"
                      class="form-control"
                      id="location"
                      placeholder="Enter location"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.location.invalid,
                        'is-valid': userFormSubmitted && !rf.location.invalid
                      }"
                      required
                      #search/> -->
                      <input  type="text" formControlName="address" class="form-control"  (keydown.enter)="$event.preventDefault()"
                       placeholder="Enter address" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search>
                    <div
                      *ngIf="
                        userFormSubmitted &&
                        (rf.address.invalid || rf.address.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Address is
                      required
                    </div>
                  </fieldset>
                  <!-- <fieldset class="form-group">
                    <label for="lat">Lat</label>
                    <input
                      type="text"
                      formControlName="lat"
                      class="form-control"
                      id="lat"
                      placeholder="Enter lat"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.lat.invalid,
                        'is-valid': userFormSubmitted && !rf.lat.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        userFormSubmitted &&
                        (rf.lat.invalid || rf.lat.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> lat is
                      required
                    </div>
                  </fieldset> -->
                  <!-- <fieldset class="form-group">
                    <label for="lng">Lng</label>
                    <input
                      type="text"
                      formControlName="lng"
                      class="form-control"
                      id="lng"
                      placeholder="Enter lng"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.lng.invalid,
                        'is-valid': userFormSubmitted && !rf.lng.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        userFormSubmitted &&
                        (rf.lng.invalid || rf.lng.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> lng is
                      required
                    </div>
                  </fieldset> -->
                  <fieldset class="form-group">
                    <label for="dob">DOB</label>
                    <input
                      type="date"
                      formControlName="dob"
                      class="form-control"
                      id="dob"
                      placeholder="Enter dob"
                      [ngClass]="{
                        'is-invalid': userFormSubmitted && rf.dob.invalid,
                        'is-valid': userFormSubmitted && !rf.dob.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="rf.dob.touched && rf.dob.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> dob is
                      required
                    </div>
                  </fieldset>
                  <fieldset>
                    <label >Gender</label>
                    <select class="form-control" aria-placeholder="Sex" (change)="change($event)">
                      <option value="" >Select Sex</option>
                      <option value="male"  >male</option>
                      <option value="female" >female</option>
                    </select>
                  </fieldset>
                </div>
               
              
<!--------------------- Student Form --------------------------------------------- -->
          <div>       
                <!-- <fieldset class="form-group">
                  <label for="bio">Bio</label>
                  <input
                    type="text"
                    formControlName="bio"
                    class="form-control"
                    id="bio"
                    placeholder="Enter bio"
                    [ngClass]="{
                      'is-invalid': userFormSubmitted && rf.bio.invalid,
                      'is-valid': userFormSubmitted && !rf.bio.invalid
                    }"
                    required
                    #bio
                  />
                  <div
                    *ngIf="rf.bio.touched && rf.bio.errors?.required"
                    class="help-block mt-1 text-danger"
                  >
                    <i class="ft-alert-circle align-middle"></i> Bio is
                    required
                  </div>
                </fieldset> -->
                <!-- <fieldset class="form-group">
                  <label for="badges">Badges</label>
                  <input
                    type="text"
                    formControlName="badges"
                    class="form-control"
                    id="badges"
                    placeholder="Enter badges"
                    [ngClass]="{
                      'is-invalid': userFormSubmitted && rf.badges.invalid,
                      'is-valid': userFormSubmitted && !rf.badges.invalid
                    }"
                    required
                    #badges
                  />
                  <div
                    *ngIf="rf.badges.touched && rf.badges.errors?.required"
                    class="help-block mt-1 text-danger"
                  >
                    <i class="ft-alert-circle align-middle"></i> Badges is
                    required
                  </div>
                </fieldset> -->
                <!-- <fieldset class="form-group">
                  <label for="goal">goal</label>
                  <input
                    type="text"
                    formControlName="goal"
                    class="form-control"
                    id="goal"
                    placeholder="Enter goal"
                    [ngClass]="{
                      'is-invalid': userFormSubmitted && rf.goal.invalid,
                      'is-valid': userFormSubmitted && !rf.goal.invalid
                    }"
                    required
                    #goal
                  />
                  <div
                    *ngIf="rf.goal.touched && rf.goal.errors?.required"
                    class="help-block mt-1 text-danger"
                  >
                    <i class="ft-alert-circle align-middle"></i> goal is
                    required
                  </div>
                </fieldset> -->
                <!-- <fieldset class="form-group">
                  <label for="mode">mode</label>
                  <input
                    type="text"
                    formControlName="mode"
                    class="form-control"
                    id="mode"
                    placeholder="Enter mode"
                    [ngClass]="{
                      'is-invalid': userFormSubmitted && rf.mode.invalid,
                      'is-valid': userFormSubmitted && !rf.mode.invalid
                    }"
                    required
                    #mode
                  />
                  <div
                    *ngIf="rf.mode.touched && rf.mode.errors?.required"
                    class="help-block mt-1 text-danger"
                  >
                    <i class="ft-alert-circle align-middle"></i> mode is
                    required
                  </div>
                </fieldset> -->
                <!-- <fieldset class="form-group">
                  <label for="hunting_by">Hunting By</label>
                  <input
                    type="text"
                    formControlName="hunting_by"
                    class="form-control"
                    id="hunting_by"
                    placeholder="Enter hunting_by"
                    [ngClass]="{
                      'is-invalid': userFormSubmitted && rf.hunting_by.invalid,
                      'is-valid': userFormSubmitted && !rf.hunting_by.invalid
                    }"
                    required
                    #hunting_by
                  />
                  <div
                    *ngIf="rf.hunting_by.touched && rf.hunting_by.errors?.required"
                    class="help-block mt-1 text-danger"
                  >
                    <i class="ft-alert-circle align-middle"></i> Hunting by is
                    required
                  </div>
                </fieldset> -->
                <!-- <fieldset class="form-group">
                  <label for="farming_by">Farming By</label>
                  <input
                    type="text"
                    formControlName="farming_by"
                    class="form-control"
                    id="farming_by"
                    placeholder="Enter farming_by"
                    [ngClass]="{
                      'is-invalid': userFormSubmitted && rf.farming_by.invalid,
                      'is-valid': userFormSubmitted && !rf.farming_by.invalid
                    }"
                    required
                    #farming_by
                  />
                  <div
                    *ngIf="rf.farming_by.touched && rf.farming_by.errors?.required"
                    class="help-block mt-1 text-danger"
                  >
                    <i class="ft-alert-circle align-middle"></i> Farming by is
                    required
                  </div>
                </fieldset> -->
                <!-- <fieldset class="form-group">
                  <label for="team">team</label>
                  <input
                    type="text"
                    formControlName="team"
                    class="form-control"
                    id="team"
                    placeholder="Enter team"
                    [ngClass]="{
                      'is-invalid': userFormSubmitted && rf.team.invalid,
                      'is-valid': userFormSubmitted && !rf.team.invalid
                    }"
                    required
                    #team
                  />
                  <div
                    *ngIf="rf.team.touched && rf.team.errors?.required"
                    class="help-block mt-1 text-danger"
                  >
                    <i class="ft-alert-circle align-middle"></i> team is
                    required
                  </div>
                </fieldset> -->
                <!-- <fieldset class="form-group">
                  <label for="college_id">college Id</label>
                  <input
                    type="text"
                    formControlName="college_id"
                    class="form-control"
                    id="college_id"
                    placeholder="Enter college_id"
                    [ngClass]="{
                      'is-invalid': userFormSubmitted && rf.college_id.invalid,
                      'is-valid': userFormSubmitted && !rf.college_id.invalid
                    }"
                    required
                    #college_id
                  />
                  <div
                    *ngIf="rf.college_id.touched && rf.college_id.errors?.required"
                    class="help-block mt-1 text-danger"
                  >
                    <i class="ft-alert-circle align-middle"></i> college_id is
                    required
                  </div>
                </fieldset> -->
          </div>
<!-------------------------- End ----------------------------------------------------->

                  <!-- <fieldset class="form-group">
                    <ng-select
                      [items]="courseList"
                      bindLabel="courseName"
                      bindValue="_id"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      placeholder="Select Course"
                      [(ngModel)]="selectedValue"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getCourseId($event)"
                    >
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <ng-select
                      [items]="batchList"
                      bindLabel="name"
                      bindValue="_id"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      placeholder="Select Batch"
                      [(ngModel)]="selectedBatch"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getBatchId($event)"
                    >
                    </ng-select>
                  </fieldset> -->
                
                </form>
              </div>
              <div class="col-md-6">
                <form [formGroup]="userForm">
                  <div>
                 
                
                
                </div>
<!--------------------- Student Form ------------------------------------------->
                <div>
                  <!-- <fieldset class="form-group">
                    <label for="project_ids">Project Ids</label>
                    <input
                      type="text"
                      id="project_ids"
                      formControlName="project_ids"
                      class="form-control"
                      placeholder="Enter project"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.project_ids.invalid,
                        'is-valid': userFormSubmitted && !rf.project_ids.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.project_ids.touched &&
                        rf.project_ids.errors?.required
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Project Ids is
                      required
                    </div>
                  </fieldset> -->
                  <!-- <fieldset class="form-group">
                    <label for="placementInfo">Placement Info</label>
                    <input
                      type="text"
                      id="placementInfo"
                      formControlName="placementInfo"
                      class="form-control"
                      placeholder="Enter Placement Info"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.placementInfo.invalid,
                        'is-valid': userFormSubmitted && !rf.placementInfo.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.placementInfo.touched &&
                        rf.placementInfo.errors?.required
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Placement Info is
                      required
                    </div>
                  </fieldset> -->
                  <!-- <fieldset class="form-group">
                    <label for="overview">overview</label>
										<textarea formControlName="overview" id="hidden-label-form-6" rows="5" class="form-control "
										 name="comment2" placeholder="Enter overview"  [ngClass]="{ 'is-invalid':
										 userFormSubmitted && rf.benfits.invalid, 'is-valid':
										 userFormSubmitted && !rf.benfits.invalid }"
										 required #overview></textarea>
										 <div *ngIf="rf.overview.touched && (rf.overview.invalid ||
											rf.overview.errors?.required)"
											class="help-block mt-1 text-danger"> <i class="ft-alert-circle
												align-middle"></i> overview is required
										</div>
                  </fieldset> -->
                  
                
                </div>
<!------------------------ End -------------------------------------------------->
                <div>
                
                  <fieldset class="form-group">
                    <label for="linkedIn">Linked In</label>
                    <input
                      type="text"
                      id="linkedIn"
                      formControlName="linkedIn"
                      class="form-control"
                      placeholder="Enter linkedIn"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.linkedIn.invalid,
                        'is-valid': userFormSubmitted && !rf.linkedIn.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.linkedIn.touched &&
                        rf.linkedIn.errors?.required
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Linked In is
                      required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="notes">Notes</label>
										<textarea formControlName="notes" id="hidden-label-form-6" rows="5" class="form-control "
										 name="comment2" placeholder="Enter who Should Join" [ngClass]="{ 'is-invalid':
										 userFormSubmitted && rf.notes.invalid, 'is-valid':
										 userFormSubmitted && !rf.notes.invalid }"
										 required #notes></textarea>
										 <div *ngIf="rf.notes.touched && (rf.notes.invalid ||
											rf.notes.errors?.required)"
											class="help-block mt-1 text-danger"> <i class="ft-alert-circle
												align-middle"></i> notes is required
										</div> 
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="admin_notes">Admin Notes</label>
										<textarea formControlName="admin_notes" id="hidden-label-form-6" rows="5" class="form-control "
										 name="comment2" placeholder="Enter who Should Join" [ngClass]="{ 'is-invalid':
										 userFormSubmitted && rf.admin_notes.invalid, 'is-valid':
										 userFormSubmitted && !rf.admin_notes.invalid }"
										 required #admin_notes></textarea>
										 <div *ngIf="rf.admin_notes.touched && (rf.admin_notes.invalid ||
											rf.admin_notes.errors?.required)"
											class="help-block mt-1 text-danger"> <i class="ft-alert-circle
												align-middle"></i> admin_notes is required
										</div> 
                  </fieldset>

                  
                  <!-- <fieldset class="form-group">
                    <label for="password">password</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="password"
                      id="name"
                      placeholder="Enter password"
                      [ngClass]="{
                        'is-invalid': userFormSubmitted && rf.password.invalid,
                        'is-valid': userFormSubmitted && !rf.password.invalid
                      }"
                      required
                      #password
                    />
                    <div
                      *ngIf="
                        rf.password.touched && rf.password.errors?.required
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Password is
                      required
                    </div>
                    <div
                      *ngIf="rf.password.errors?.minlength"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Password must
                      be at least 4 characters
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="confirmPassword">confirm Password</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="confirmPassword"
                      id="confirmPassword"
                      placeholder="Enter confirm Password"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.confirmPassword.invalid,
                        'is-valid':
                          userFormSubmitted && !rf.confirmPassword.invalid
                      }"
                      required
                      #confirmPassword
                    />
                    <div
                      *ngIf="
                        rf.confirmPassword.touched &&
                        rf.confirmPassword.errors?.required
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Confirm
                      Password is required
                    </div>
                    <div
                      *ngIf="rf.password.value !== rf.confirmPassword.value"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Confirm
                      Passwords doesn't match
                    </div>
                  </fieldset> -->
                  <fieldset class="form-group">
                    <input
                      type="file"
                      class="form-control"
                      formControlName="image"
                      required
                      (change)="onSelectFile($event)"
                    />
                  </fieldset>
                </div>
                 
                  <div
                    class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2" >
                    <button
                      type="submit"
                      class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                      [disabled]="
                        name.value.length === 0 ||
                        email.value.length === 0 ||
                        phone.value.length === 0 "
                      (click)="submitForm()"
                    >
                      Submit
                    </button>
                    <button
                      type="reset"
                      class="btn btn-secondary"
                      (click)="back()"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- --------------------------Student Form---------------------------------- -->
<div class="row"  *ngIf="currentUrl == 'student-add' ">
  <div class="col-12">
    <div class="content-header">Student Form</div>
  </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input"  *ngIf="currentUrl == 'student-add' ">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Basic</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form [formGroup]="studentForm">
                  <div>
                  <!-- <fieldset class="form-group">
                    <label for="users-list-role">Role</label>                    
                   
                    <input
                      type="text"
                      class="form-control"
                      formControlName="roles"
                      id="roles"
                      placeholder="Enter role"
                      [ngClass]="{
                        'is-invalid': userFormSubmitted && rf.roles.invalid,
                        'is-valid': userFormSubmitted && !rf.roles.invalid
                      }"
                      required
                      #roles
                    />
                    <div
                      *ngIf="rf.roles.touched && rf.roles.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> role is
                      required
                    </div>
                  </fieldset> -->
 <!-- <ng-select
                      [items]="roles"
                      bindLabel="type"
                      bindValue="_id"
                      [multiple]="false"
                      [closeOnSelect]="false"
                      placeholder="Select Role"
                      [(ngModel)]="selectedRole"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getRoleId($event)"
                    >
                    </ng-select> -->


                  <fieldset class="form-group">
                    <label for="name">Name</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="name"
                      id="name"
                      placeholder="Enter name"
                      [ngClass]="{
                        'is-invalid': userFormSubmitted && rf.name.invalid,
                        'is-valid': userFormSubmitted && !rf.name.invalid
                      }"
                      required
                      #name
                    />
                    <div
                      *ngIf="rf.name.touched && rf.name.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Name is
                      required
                    </div>
                  </fieldset>

                  <fieldset class="form-group">
                    <label for="Email">Email</label>
                    <input
                      type="email"
                      class="form-control"
                      formControlName="email"
                      id="Email"
                      placeholder="Enter email"
                      [ngClass]="{
                        'is-invalid': userFormSubmitted && rf.email.invalid,
                        'is-valid': userFormSubmitted && !rf.email.invalid
                      }"
                      required
                      #email
                    />
                    <div
                      *ngIf="rf.email.touched && rf.email?.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Email is
                      required
                    </div>
                    <div
                      *ngIf="rf.email.errors?.email"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Please enter
                      a valid email address
                    </div>
                  </fieldset>

                  <fieldset class="form-group">
                    <label for="phone">Phone</label>
                    <input
                    type="text" 
                    placeholder="e.g. (555) 555 5555" mask="(000) 000-0000" minlength="10"
                      formControlName="phone"
                      class="form-control"
                      id="phone"
                      placeholder="Enter phone"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.phone.invalid,
                        'is-valid':
                          userFormSubmitted && !rf.phone.invalid
                      }"
                      required
                      #phone
                    />
                    <div
                      *ngIf="
                        rf.phone.touched && rf.phone.errors?.required
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i>
                      phone is required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="location">Location</label>
                    <!-- <input
                      type="text"
                      formControlName="location"
                      class="form-control"
                      id="location"
                      placeholder="Enter location"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.location.invalid,
                        'is-valid': userFormSubmitted && !rf.location.invalid
                      }"
                      required
                      #search/> -->
                      <input  type="text" class="form-control"  (keydown.enter)="$event.preventDefault()"
                       placeholder="Enter Location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search>
                    <div
                      *ngIf="
                        userFormSubmitted &&
                        (rf.location.invalid || rf.location.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> location is
                      required
                    </div>
                  </fieldset>
                  <!-- <fieldset class="form-group">
                    <label for="lat">Lat</label>
                    <input
                      type="text"
                      formControlName="lat"
                      class="form-control"
                      id="lat"
                      placeholder="Enter lat"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.lat.invalid,
                        'is-valid': userFormSubmitted && !rf.lat.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        userFormSubmitted &&
                        (rf.lat.invalid || rf.lat.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> lat is
                      required
                    </div>
                  </fieldset> -->
                  <!-- <fieldset class="form-group">
                    <label for="lng">Lng</label>
                    <input
                      type="text"
                      formControlName="lng"
                      class="form-control"
                      id="lng"
                      placeholder="Enter lng"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.lng.invalid,
                        'is-valid': userFormSubmitted && !rf.lng.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        userFormSubmitted &&
                        (rf.lng.invalid || rf.lng.errors?.required)
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> lng is
                      required
                    </div>
                  </fieldset> -->
                  <fieldset class="form-group">
                    <label for="dob">DOB</label>
                    <input
                      type="date"
                      formControlName="dob"
                      class="form-control"
                      id="dob"
                      placeholder="Enter dob"
                      [ngClass]="{
                        'is-invalid': userFormSubmitted && rf.dob.invalid,
                        'is-valid': userFormSubmitted && !rf.dob.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="rf.dob.touched && rf.dob.errors?.required"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> dob is
                      required
                    </div>
                  </fieldset>
                  <fieldset>
                    <Label>Sex</Label>
                    <select class="form-control" aria-placeholder="Sex" (change)="change($event)">
                      <option value="sex" >Select Gender</option>
                      <option value="male"  >male</option>
                      <option value="female" >female</option>
                    </select>
                  </fieldset>
                </div>
               
              
<!--------------------- Student Form --------------------------------------------- -->
          <div>       
                 <fieldset class="form-group">
                  <label for="bio">Bio</label>
                  <input
                    type="text"
                    formControlName="bio"
                    class="form-control"
                    id="bio"
                    placeholder="Enter bio"
                    [ngClass]="{
                      'is-invalid': userFormSubmitted && rf.bio.invalid,
                      'is-valid': userFormSubmitted && !rf.bio.invalid
                    }"
                    required
                    #bio
                  />
                  <!-- <div
                    *ngIf="rf.bio.touched && rf.bio.errors?.required"
                    class="help-block mt-1 text-danger"
                  >
                    <i class="ft-alert-circle align-middle"></i> Bio is
                    required
                  </div> -->
                </fieldset> 
                <fieldset class="form-group">
                  <label class="form-control-label" for="badges">
                    Student Badge</label
                  >
                  <ng-select
                    [items]="badgeList"
                    bindLabel="name"
                    bindValue="_id"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    placeholder="Select Badge"
                    [(ngModel)]="selectBadge"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getBadgeId($event)"
                  >
                  </ng-select>
                </fieldset>
                <!-- <fieldset class="form-group">
                  <label for="goal">goal</label>
                  <input
                    type="text"
                    formControlName="goal"
                    class="form-control"
                    id="goal"
                    placeholder="Enter goal"
                    [ngClass]="{
                      'is-invalid': userFormSubmitted && rf.goal.invalid,
                      'is-valid': userFormSubmitted && !rf.goal.invalid
                    }"
                    required
                    #goal
                  />
                  <div
                    *ngIf="rf.goal.touched && rf.goal.errors?.required"
                    class="help-block mt-1 text-danger"
                  >
                    <i class="ft-alert-circle align-middle"></i> goal is
                    required
                  </div>
                </fieldset> -->
                <!-- <fieldset class="form-group">
                  <label for="mode">mode</label>
                  <input
                    type="text"
                    formControlName="mode"
                    class="form-control"
                    id="mode"
                    placeholder="Enter mode"
                    [ngClass]="{
                      'is-invalid': userFormSubmitted && rf.mode.invalid,
                      'is-valid': userFormSubmitted && !rf.mode.invalid
                    }"
                    required
                    #mode
                  />
                  <div
                    *ngIf="rf.mode.touched && rf.mode.errors?.required"
                    class="help-block mt-1 text-danger"
                  >
                    <i class="ft-alert-circle align-middle"></i> mode is
                    required
                  </div>
                </fieldset> -->
                <fieldset class="form-group">
                  <label class="form-control-label" for="huntingBy"
                    >Hunting by</label
                  >
                  <ng-select
                    [items]="usersList"
                    bindLabel="name"
                    bindValue="_id"
                    placeholder="Hunting By"
                    [(ngModel)]="selectedHuntingBy"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getHuntId($event)"
                  >
                  </ng-select>
                </fieldset>
                <fieldset class="form-group">
                  <label class="form-control-label" for="farmingBy"
                    >Farming by</label
                  >
                  <ng-select
                    [items]="usersList"
                    bindLabel="name"
                    bindValue="_id"
                    placeholder="Farming By"
                    [(ngModel)]="selectedFarmingBy"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getFarmId($event)"
                  >
                  </ng-select>
                </fieldset>
                <fieldset class="form-group">
                  <label class="form-control-label" for="goal"
                    >Team</label
                  >
                  <ng-select
                    [items]="teamList"
                    bindLabel="displayname"
                    bindValue="_id"
                    [closeOnSelect]="true"
                    placeholder="Select Team"
                    [(ngModel)]="selectedTeam"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getTeamId($event)"
                  >
                  </ng-select>
                </fieldset>
                <fieldset class="form-group">
                  <label for="">College</label>
                  <ng-select
                    [items]="collegeList"
                    bindLabel="name"
                    bindValue="_id"
                    placeholder="Select College"
                    [(ngModel)]="selectedCollege"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="getCollegeId($event)"
                    #college="ngModel"
                  >
                  </ng-select>
                </fieldset>
          </div>
<!-------------------------- End ----------------------------------------------------->
                  <!-- <fieldset class="form-group">
                    <ng-select
                      [items]="batchList"
                      bindLabel="name"
                      bindValue="_id"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      placeholder="Select Batch"
                      [(ngModel)]="selectedBatch"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getBatchId($event)"
                    >
                    </ng-select>
                  </fieldset>  -->
                
                </form>
              </div>
              <div class="col-md-6">
                <form [formGroup]="studentForm">
                  <div>
                 
                
                
                </div>
<!--------------------- Student Form ------------------------------------------->
                <div>
                  <fieldset class="form-group">
                    <label>Course</label>
                    <ng-select
                      [items]="courseList"
                      bindLabel="title"
                      bindValue="_id"
                      placeholder="Select Course"
                      [(ngModel)]="selectedCourse"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getCourseId($event)"
                    >
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="next_payment_date"> Next Payment Date </label>
                    <input type="date"  formControlName="next_payment_date" class="form-control "
                     name="comment2" placeholder="Enter  Next Payment Date "
                     required #next_payment_date>
                  </fieldset>
              
                <fieldset class="form-group">
                  <label for="last_qualification"> Last Qualification </label>
                  <input formControlName="last_qualification" class="form-control "
                   name="comment2" placeholder="Enter Last Qualification "
                   required #last_qualification>
                </fieldset>
                   <fieldset class="form-group">
                    <label for="project_ids">Project Ids</label>
                    <input
                      type="text"
                      id="project_ids"
                      formControlName="project_ids"
                      class="form-control"
                      placeholder="Enter project" />
                   
                  </fieldset> 

                   <fieldset class="form-group">
                    <label for="placementinfo">Placement Info</label>
                    <input
                      type="text"
                      id="placementinfo"
                      formControlName="placementinfo"
                      class="form-control"
                      placeholder="Enter Placement Info"/>
               
                  </fieldset> 
                <fieldset class="form-group">
                    <label for="overview">overview</label>
										<textarea formControlName="overview" id="hidden-label-form-6" rows="5" class="form-control "
										 name="comment2" placeholder="Enter overview" 
										 required #overview></textarea>
                  </fieldset>               
                </div>
<!------------------------ End -------------------------------------------------->
                <div>
                
                  <!-- <fieldset class="form-group">
                    <label for="linkedIn">Linked In</label>
                    <input
                      type="text"
                      id="linkedIn"
                      formControlName="linkedIn"
                      class="form-control"
                      placeholder="Enter linkedIn"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.linkedIn.invalid,
                        'is-valid': userFormSubmitted && !rf.linkedIn.invalid
                      }"
                      required
                    />
                    <div
                      *ngIf="
                        rf.linkedIn.touched &&
                        rf.linkedIn.errors?.required
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Linked In is
                      required
                    </div>
                  </fieldset> -->
                  <fieldset class="form-group">
                    <label for="notes">Notes</label>
										<textarea formControlName="notes" id="hidden-label-form-6" rows="5" class="form-control "
										 name="comment2" placeholder="Enter Notes "
										 required #notes></textarea>
										
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="admin_notes">Admin Notes</label>
										<textarea formControlName="admin_notes" id="hidden-label-form-6" rows="5" class="form-control "
										 name="comment2" placeholder="Enter Admin Notes" 
										 required #admin_notes></textarea>
										
                  </fieldset>

                  
                  <!-- <fieldset class="form-group">
                    <label for="password">password</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="password"
                      id="name"
                      placeholder="Enter password"
                      [ngClass]="{
                        'is-invalid': userFormSubmitted && rf.password.invalid,
                        'is-valid': userFormSubmitted && !rf.password.invalid
                      }"
                      required
                      #password
                    />
                    <div
                      *ngIf="
                        rf.password.touched && rf.password.errors?.required
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Password is
                      required
                    </div>
                    <div
                      *ngIf="rf.password.errors?.minlength"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Password must
                      be at least 4 characters
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="confirmPassword">confirm Password</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="confirmPassword"
                      id="confirmPassword"
                      placeholder="Enter confirm Password"
                      [ngClass]="{
                        'is-invalid':
                          userFormSubmitted && rf.confirmPassword.invalid,
                        'is-valid':
                          userFormSubmitted && !rf.confirmPassword.invalid
                      }"
                      required
                      #confirmPassword
                    />
                    <div
                      *ngIf="
                        rf.confirmPassword.touched &&
                        rf.confirmPassword.errors?.required
                      "
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Confirm
                      Password is required
                    </div>
                    <div
                      *ngIf="rf.password.value !== rf.confirmPassword.value"
                      class="help-block mt-1 text-danger"
                    >
                      <i class="ft-alert-circle align-middle"></i> Confirm
                      Passwords doesn't match
                    </div>
                  </fieldset> -->
                  <!-- <fieldset class="form-group">
                    <input
                      type="file"
                      class="form-control"
                      formControlName="image"
                      required
                      (change)="onSelectFile($event)"
                    />
                  </fieldset> -->
                </div>
                 
                  <div
                    class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2" >
                    <button
                      type="submit"
                      class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                      [disabled]="
                        name.value.length === 0 ||
                        email.value.length === 0 ||
                        phone.value.length === 0 "
                      (click)="submitStudentForm()"
                    >
                      Submit
                    </button>
                    <button
                      type="reset"
                      class="btn btn-secondary"
                      (click)="back()"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

